import { getResponsiveFactorSizeResolver } from '../../resolvers/CurryingResolvers';
export default function resolvePadding(theme, screenWidth, paddingSupport) {
    var result = {};
    var sizeResolver = getResponsiveFactorSizeResolver(theme, theme.designGrid.padding, screenWidth);
    if (paddingSupport.padding !== undefined) {
        result.padding = sizeResolver(paddingSupport.padding);
    }
    if (paddingSupport.paddingTopBottom !== undefined) {
        var paddingTopBottom = sizeResolver(paddingSupport.paddingTopBottom);
        result.paddingTop = paddingTopBottom;
        result.paddingBottom = paddingTopBottom;
    }
    if (paddingSupport.paddingRightLeft !== undefined) {
        var paddingRightLeft = sizeResolver(paddingSupport.paddingRightLeft);
        result.paddingRight = paddingRightLeft;
        result.paddingLeft = paddingRightLeft;
    }
    if (paddingSupport.paddingTop !== undefined) {
        result.paddingTop = sizeResolver(paddingSupport.paddingTop);
    }
    if (paddingSupport.paddingBottom !== undefined) {
        result.paddingBottom = sizeResolver(paddingSupport.paddingBottom);
    }
    if (paddingSupport.paddingRight !== undefined) {
        result.paddingRight = sizeResolver(paddingSupport.paddingRight);
    }
    if (paddingSupport.paddingLeft !== undefined) {
        result.paddingLeft = sizeResolver(paddingSupport.paddingLeft);
    }
    return result;
}
//# sourceMappingURL=PaddingResolver.js.map